import React from 'react';
import PropTypes from 'prop-types';

import getInitialsFromName from 'utils/getInitialsFromName';
import getImageStyle from 'utils/getImageStyle';

import Spy from 'icons/Spy';

import AvatarContainer from './AvatarContainer';

const SCALES = {
  '32px': '0.5',
  '40px': '0.6',
  '56px': '0.8',
  '64px': '0.8',
};

export class Avatar extends React.PureComponent {
  state = {
    hasImage: false,
  }

  componentDidMount() {
    this.checkImageExist();
  }

  componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this.setState({ hasImage: false }); // eslint-disable-line react/no-did-update-set-state
      this.checkImageExist();
    }
  }

  componentWillUnmount() {
    if (this.image) {
      this.image.removeEventListener('load', this.handleImageLoad);
    }
  }

  get initials() {
    return this.props.name ? getInitialsFromName(this.props.name) : '';
  }

  get src() {
    if (!this.props.url) return '';

    const size = this.props.size.slice(0, this.props.size.indexOf('px'));
    return getImageStyle(this.props.url, `${size}x${size}`);
  }

  handleImageLoad = () => {
    this.setState({ hasImage: true });
  }

  checkImageExist() {
    if (!this.props.url) return;

    this.image = new window.Image();
    this.image.addEventListener('load', this.handleImageLoad);
    this.image.src = this.src;
  }

  render() {
    return (
      <AvatarContainer
        style={{
          width: this.props.size,
          height: this.props.size,
          fontSize: this.props.fontSize,
        }}
        image={this.state.hasImage ? this.src : ''}
        hasBorder={this.props.hasBorder}
      >
        {!this.state.hasImage && (
          this.initials || (<Spy scale={SCALES[this.props.size]} />)
        )}
      </AvatarContainer>
    );
  }
}

Avatar.propTypes = {
  name: PropTypes.string,
  size: PropTypes.string,
  url: PropTypes.string,
  fontSize: PropTypes.string,
  hasBorder: PropTypes.bool,
};

Avatar.defaultProps = {
  name: '',
  size: '88px',
  url: '',
  fontSize: '18px',
  hasBorder: false,
};

export default Avatar;
